import { render, staticRenderFns } from "./WhatsappStartChat.vue?vue&type=template&id=d8af9848&scoped=true"
import script from "./WhatsappStartChat.vue?vue&type=script&lang=js"
export * from "./WhatsappStartChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8af9848",
  null
  
)

export default component.exports